import { hasFeature } from '@/services/featureService';
import { isAdminOrSupervisor } from '@/services/userService';
import { Feature } from '@/utils/constant';
import type { ExtendedUserResponseSchema } from '@/types/user.types';

export const canShareHIAttemptUpdates = (
  user: ExtendedUserResponseSchema | null,
  hasAttempts: boolean,
  options?: { status?: string | null; contactEmail?: string | null }
): boolean => {
  if (!hasAttempts) return false;
  if (options?.status === 'CANCELED') return false;
  if (!options?.contactEmail?.trim()) return false;
  if (!hasFeature(Feature.HOME_INSPECTION) || !hasFeature(Feature.HOME_INSPECTION_SHARE_UPDATES)) {
    return false;
  }
  if (!user) return false;
  if (isAdminOrSupervisor(user)) return true;
  return user.teams?.some((t) => t.key === 'SERVICE') ?? false;
};
